"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M44.7917 26.6666H34.0208V9.7083C34.0236 9.50234 33.9851 9.2979 33.9076 9.10706C33.8301 8.91622 33.7151 8.74286 33.5694 8.5972C33.4238 8.45155 33.2504 8.33656 33.0596 8.25903C32.8687 8.1815 32.6643 8.143 32.4583 8.1458H18.1875C17.7804 8.15666 17.3936 8.32607 17.1095 8.61792C16.8254 8.90978 16.6665 9.30102 16.6667 9.7083V19.8125H5.20834C4.79394 19.8125 4.39651 19.9771 4.10348 20.2701C3.81046 20.5631 3.64584 20.9606 3.64584 21.375V40.3125C3.65123 40.7252 3.81758 41.1195 4.10945 41.4114C4.40131 41.7032 4.79561 41.8696 5.20834 41.875H44.7917C45.2044 41.8696 45.5987 41.7032 45.8906 41.4114C46.1824 41.1195 46.3488 40.7252 46.3542 40.3125V28.2291C46.3542 27.8147 46.1895 27.4173 45.8965 27.1243C45.6035 26.8313 45.2061 26.6666 44.7917 26.6666ZM43.2292 38.75H6.77084V22.9166H18.1875C18.6002 22.9112 18.9945 22.7449 19.2864 22.453C19.5783 22.1612 19.7446 21.7669 19.75 21.3541V11.2708H30.8958V28.2291C30.9012 28.6419 31.0676 29.0362 31.3594 29.328C31.6513 29.6199 32.0456 29.7862 32.4583 29.7916H43.2292V38.75Z",
    fill: fill
  }));
};

exports["default"] = _default;